export default {
  queryCourierBankCard: '/courier/api/v3/queryCourierBankCard'
}
